// extracted by mini-css-extract-plugin
export default {"wrapper":"TimerComponent_wrapper__F7giG"};